/**
 * Fuso padrão de uma conta que NÃO definiu `reporting_timezone`.
 *
 * Espelha `Appointments::BusinessTimezone::DEFAULT_TIMEZONE`
 * (app/services/appointments/business_timezone.rb): no servidor, conta sem fuso
 * é tratada como BRT — é nesse fuso que a disponibilidade é calculada e que o
 * horário digitado é interpretado.
 *
 * O front caía em 'UTC' em 12 telas (follow-ups, broadcasts, pipeline), o que
 * desloca tudo três horas do que o servidor construiu. Sintomas medidos em
 * 2026-08-24 no chatdev, com follow-up agendado para 22h BRT:
 *   - o filtro "Hoje" NÃO o mostrava (para o filtro, 22h BRT já é o dia
 *     seguinte em UTC), e foi esse o relato do cliente;
 *   - a lista imprimia "12:00" para um follow-up das 09h BRT.
 *
 * A Agenda de Agendamentos já tinha sido corrigida isoladamente e carregava
 * este literal duplicado; agora consome daqui.
 */
export const REPORTING_DEFAULT_TIMEZONE = 'America/Sao_Paulo';

export default REPORTING_DEFAULT_TIMEZONE;
